import {useRef, useState} from 'react';
import {LeftPageHeader} from 'Components/Public/PageHeader/PageHeader';
import { data } from './SurveillanceData';
import {IconTextButton} from "../../../Components/Button";
import {ICONS} from "../../../Utils/icons";
import {httpDownload} from "../../../Utils/httpDownload";
import {useSelector} from "react-redux";
import {setGlobalErrorStatus} from "../../../Components/StatusHandling";
import {ERROR_MESSAGES} from "../../../Utils/constants";
import { useDispatch } from 'react-redux';
import DocumentTemplate from 'Components/Public/DocumentTemplate';
import Feedback from "../../../Components/Public/Feedback/Feedback";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";

//DOWNLOAD
function SurveillanceFormats() {
  const sectionRefs = useRef({});
  const allResourceGroupId = "2845";
  const loginInfo = useSelector(state => state.loginInfo);
  const [isDownloading, setIsDownloading] = useState(false);
  const dispatch = useDispatch();
  
  const handleFileDownload = async () => {
    if(!isDownloading) {
      setIsDownloading(true);
      const res = await getDocumentDownloadCall();
      
      if (res) {
        //console.log("handleFileDownload", res);
        // get filename from the res content-disposition
        const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
        //console.log("handleFileDownload", filename)
        let url = window.URL.createObjectURL(res.data);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.GENERAL_ERROR.title,
            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        })
      }
      setTimeout(() => {
        //console.log("after file download");
        setIsDownloading(false);
      }, 1000);
    }
  }
  
  const getDocumentDownloadCall = async () => {
    
    var url = '/api/dlms/downloadDocument';
    
    return httpDownload.post(url, { "groupId": allResourceGroupId }, {
      responseType: 'blob',
      headers: {
        "Authorization": "Bearer " + loginInfo.token
      }
    });
  }
  
  return (
    <>
      <ReCaptchaWrapper
        action="surveillance_v1_0_landing"
        title="Surveillance - Hospital Version 1.0"
      >
          <LeftPageHeader
              subTitle= "COMMON FORMATS"
              title="Surveillance - Hospital Version 1.0"
              intro={null}
              rightContent={
                <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content ms-auto me-auto h-100 justify-content-center mt-2 mb-2">
                      {/* <IconTextButton
                          className="reverse button-width text-center w-100 d-flex justify-content-center"
                          icon={ICONS.download}
                          onClick={handleFileDownload}
                          variant="outline-clear"
                          content={"Download all Resources"}
                      /> */}
                    <IconTextButton
                        className="reverse button-width text-center w-100 d-flex justify-content-center"
                        icon={ICONS.download}
                        //onClick={handleAllFileDownload}
                        variant="outline-clear"
                        content={"Download all Resources"}
                        groupId={allResourceGroupId}
                    />
                  </div>
          }
        ></LeftPageHeader>
        
        <DocumentTemplate commonFormatsData={data} ref={sectionRefs} />
        <Feedback/>
      </ReCaptchaWrapper>
    </>
  );
}

export default SurveillanceFormats;